import React from "react";
import {
  Link
} from "react-router-dom";
import { withRouter, VirsionCheck, Faq } from "../../Helpers/Common"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { motion } from "framer-motion";
import { userprofile } from "../../Model/Users"; //Include Home
import $ from "jquery";
import Parser from "html-react-parser";
import Profilemenu from "../Profile_menu/Profilemenu";
import BarLoader from "react-spinners/BarLoader";
import { Metadata } from "../Metadata/Metadata";
import FooterEth from "../common/FooterEth";
import HeaderEth from "../common/HeaderEth";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Helpsupport extends React.Component {
  render() {
    return (
      <>
        <Metadata page="FAQ" />
        <HeaderEth />
        <main className="TermsofUse helpnsupport">
          <div >
            <div className="homeBanner">
              <div className="innerBanner mb-0">
                <div className="policy-title" >
                  <h1 style={{ fontSize: "20px !important" }}>Frequently Asked Questions:<span className="red"> DocuBay documentary video on demand Service.</span></h1>
                </div>
              </div>
            </div>
            <div className="temp37">
              <div className="temp37-inn helpnsupportinn">
                <p><div style={{ fontWeight: "800" }}>Q1: What is a DocuBay Documentary VOD Service? </div></p>
                <ul>
                  <li>DocuBay is a global video streaming platform designed specifically for streaming Video on demand documentaries from around the world which will be delivered to customers with daily and weekly subscription.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q2: Are subtitles available for documentaries on the DocuBay app?</div></p>
                <ul>
                  <li>Yes. Subtitles are available for most of the documentaries. Also further works are being done towards enabling subtitles for all our content.</li>
                  <li>Currently, English is the only supported language for subtitles and more languages will be added soon.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q3: What kind of contents are available in DocuBay service?</div></p>
                <ul>
                  <li>Adventure, Crime, Culture, Eco, History, Humanity, Nature, Politics, Science, Tech, Travel and War contents are available for the subscribers.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q4: Is DocuBay Documentary VOD Service available for all?</div></p>
                <ul>
                  <li>The DocuBay Documentary VOD Service is available to all customers (pre-paid, hybrid and post-paid) of Ethio telecom. </li>
                  <li>To subscribe to the service, the service number must be on active status and have balance/package.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q5. Which platform is compatible for DocuBay Documentary VOD Service? </div></p>
                <ul>
                  <li>DocuBay Documentary VOD Service is accessible currently through mobile smartphone and Web portal.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q6. How can I subscribe to DocuBay service?</div></p>
                <ul>
                  <li>You need to send A or B keywords to 9012 via SMS to subscribe to the Daily or Weekly offer. Ones subscribed, the user will receive portal link that would allow him to login and access contents.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q7. How do I login to the content portal?</div></p>
                <ul>
                  <li>You can login to https://et.docubay.com using your phone number that you would have used at the time of Subscription.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q8: Do I need to subscribe before I can start watching any content?</div> </p>
                <ul>
                  <li>
                    Yes, you need to subscribe to the service to enjoy the contents in the DocuBay. It is completely hassle free. Ones you have subscribed for the service using 9012, then go to https://et.docubay.com/  this link will be sent to you from 9012 also during your subscription process.
                    <li>
                      Then Inputs mobile number and click on Get OTP to get PIN.
                    </li>
                    <li>
                      Finally, you will input the PIN received from 9012 to login and access the Docubay VOD content service via their smartphone, tablet or PC.
                    </li>
                    <li>
                      You will get free trial for 1 day during your 1st subscription.
                    </li>
                  </li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q9: How much does the service cost??</div> </p>
                <ul>
                  <li>The service has two subscription plans. The Daily plan costs 3Br. Per day and the Weekly plan costs 12Br. Per week. All users are given a 1-day free trial period to give it a test. And all payments are in a recurring plan.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q10: Are there any possibilities for service access restrictions?</div></p>
                <ul>
                  <li>Yes, there are. For the user to access the services it is must that he/she is a subscriber. Also, while being a subscriber the customer should pay a daily/weekly service fee depending on their subscription.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q11. What if I am unable to log in due to Device login limit? Can I log-out from the devices? </div></p>
                <ul>
                  <li>If they only have the logged-in device at hand, surely, they can log-out from it. But if not, they need to wait for the next day to log-in as all sessions will be killed in the mid-night/</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q12: How can I unsubscribe from the service?</div></p>
                <ul>
                  <li>To unsubscribe the service, Customer need to send STOP A or STOP B to 9012 via SMS for Daily and Weekly subscriptions respectively.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q13: Does the service require internet connection?</div></p>
                <ul>
                  <li>Yes! Customer can either use Mobile data or WiFi to get access to the service.</li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q14: Can we get the application on Smart (android) TVs?</div></p>
                <ul>
                  <li>Development of an application for android tv is in progress and we will notify you once available. </li>
                </ul>

                <p><div style={{ fontWeight: "800" }}>Q15: What are some of the issues that can be faced while using the service? </div></p>
                <ul>
                  <li>In case you face still some issue with the service, contact our customer support team via partner (Mobile Spin Support) </li>
                </ul>
              </div>
            </div>
          </div>
        </main>
        <FooterEth />
      </>
    );
  }
}
export default withRouter(Helpsupport);
